import React, { Component, PropTypes } from 'react';
import cx from 'classnames';

const OPTION_STYLE = { minWidth: 32, textAlign: 'center', marginTop: 8 };

export default class PageTabs extends Component {
  static propTypes = {
    options: PropTypes.arrayOf(PropTypes.node).isRequired,
    active: PropTypes.number.isRequired,
    onActiveChange: PropTypes.func.isRequired
  };

  render() {
    const { options, active, className, onActiveChange } = this.props;

    return (
      <div className={cx(className, 'font-weight-bolder overflow-x-auto')}>
        {
          options.map((opt, ix) => {
            const activeTab = (ix === active);

            const optionClassName = cx(
              'display-inline-block pd-left-sm pd-right-sm lg-font',
              'border-bottom-style-solid border-bottom-width-4px',
              {
                'border-bottom-color-rich-orange color-primary': activeTab,
                'border-bottom-color-transparent color-medium-gray cursor-pointer': !activeTab
              }
            );

            return (
              <span key={ix} onClick={() => onActiveChange(ix)} className={optionClassName} style={OPTION_STYLE}>
                {opt}
              </span>
            );
          })
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/layout/PageTabs.jsx